import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const clinicUuidCookieName = 'selectedClinic';

export const getSelectedClinicUuid = () => cookies.get(clinicUuidCookieName);

export const setSelectedClinicUuid = (value: string) => {
  if (cookies.get(clinicUuidCookieName) !== value) {
    cookies.set(clinicUuidCookieName, value, { path: '/' });
  }
};

export const clearSelectedClinicUuid = () => {
  if (cookies.get(clinicUuidCookieName)) {
    cookies.remove(clinicUuidCookieName, { path: '/' });
  }
};
